import React from 'react'
import { Box } from '@mui/material'
import Sparkles from 'react-sparkle'
import { motion, useTransform } from 'framer-motion'
import { INTERAX_COLORS } from '../../../constants/colors'
import { useGlowCursor } from './GlowCursor'

const MotionBox = motion(Box)
const SPARKLE_CONTAINER_SIZE = 180

export interface SparkleCursorProps {
  active: boolean
  color?: string
  count?: number
}

export const SparkleCursor: React.FC<SparkleCursorProps> = ({ active, color = INTERAX_COLORS.sun, count = 24 }) => {
  const { isActive, cursorMotion } = useGlowCursor()

  const offsetX = useTransform(cursorMotion.x, (value) => value - 200)
  const offsetY = useTransform(cursorMotion.y, (value) => value)

  if (!active || !isActive) {
    return null
  }

  return (
    <MotionBox
      sx={{
        pointerEvents: 'none',
        position: 'fixed',
        zIndex: 30,
        width: `${SPARKLE_CONTAINER_SIZE}px`,
        height: `${SPARKLE_CONTAINER_SIZE}px`
      }}
      style={{
        x: offsetX,
        y: offsetY,
        translateX: '-50%',
        translateY: '-50%'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%'
        }}
      >
        <Sparkles
          color={color}
          count={count}
          overflowPx={48}
          fadeOutSpeed={18}
          minSize={6}
          maxSize={12}
          flickerSpeed="fast"
          flicker
        />
      </Box>
    </MotionBox>
  )
}

export default SparkleCursor
